<div class="email-tag-field" data-e2e-id="email-tag-field">
  <label
    class="email-tag-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
    [attr.for]="fieldId"
  >
    {{ label }}
  </label>

  <div class="email-tag-wrapper" [class.has-error]="hasMaxRecipients">
    <!--
             use `autocomplete` attr with arbitrary value `AutoCompleteOff`
             because Chrome couldn't handle `autocomplete="off"` correctly
             @see https://stackoverflow.com/questions/12374442/chrome-ignores-autocomplete-off

             The insignia library for email tag also has an issue with autocomplete
             @see https://invoice2go.atlassian.net/browse/I2G-1116
        -->
    <input
      class="input"
      appEmailTag
      [limit]="limit"
      tabindex="0"
      [focusable]="focusableTrigger$"
      [attr.id]="fieldId"
      [formControl]="formControl"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      autocomplete="AutocompleteOff"
      (onBlur)="onInputBlur()"
      (onFocus)="onFocus.emit()"
      (emailTag)="valueUpdated($event)"
      (hitMaxTags)="onHitMaxTags($event)"
    />
  </div>
</div>

<div class="email-alert-wrapper">
  <i2g-note
    *ngIf="hasMaxRecipients"
    class="email-field-alert"
    noteStyle="alert"
    [message]="maxRecipientsMessage"
  >
  </i2g-note>
</div>
